import useLatest from "@src/hooks/useLatest";
import { useEffect } from "react";
import { appBus, AppBusEvents } from "../../events/bus";

export function useAppBusEvent<K extends keyof AppBusEvents>(
  event: K,
  handler: (data: AppBusEvents[K]) => void,
) {
  const latestHandler = useLatest(handler);

  useEffect(() => {
    const listener = (data: AppBusEvents[K]) => {
      latestHandler.current(data);
    };

    appBus.on(event, listener);

    return () => {
      appBus.off(event, listener);
    };
  }, [event]);
}
